import {
  cardTitle,
  dangerColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";
import modalStyle from "../modalStyle";
import customSelectStyle from "../customSelectStyle";

const exchangeRatesStyle = (theme) => ({
  ...modalStyle(theme),
  ...customSelectStyle(theme),
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  topInformation: {
    fontSize: "16px",
    width: "100%",
  },
  standardCurrency: {
    marginTop: "20px",
  },
  additionalCurrencies: {
    marginTop: "20px",
  },
  additionalCurrencyButtons: {
    marginTop: "0",
    marginLeft: "-2px",
    "& > button": {
      paddingLeft: "8px",
      paddingRight: "15px",
      marginRight: "5px",
      "& > span > svg": {
        marginTop: "-2px",
      },
    },
  },
  attention: {
    animation: "$attention 3s ease infinite",
  },
  "@keyframes attention": {
    "10%": {
      transform: "scale(1.1)",
    },
    "13.33%,20%": {
      transform: "rotate(-10deg) scale(1.1)",
    },
    "16.67%": {
      transform: "rotate(10deg) scale(1.1)",
    },
    "23.33%": {
      transform: "rotate(0deg) scale(1.1)",
    },
    "33%": {
      transform: "scale(1)",
    },
  },
  instructionsWrapper: {
    width: "100%",
  },
  instructionsHeader: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      opacity: 0.8,
    },
  },
  instructionsTitle: {
    fontSize: "16px",
  },
  comments: {
    width: "100%",
    marginTop: "8px",
    fontSize: "12px",
    lineHeight: "1.6",
  },
  tableWrapper: {
    marginTop: "6px",
    width: "100%",
    display: "inline-block",
    overflow: "hidden",
    "@media (max-width: 1320px)": {
      overflow: "auto !important",
    },
  },
  currencyTable: {
    width: "100%",
    whiteSpace: "nowrap",
    display: "table-row",
    position: "relative",
  },
  currencyTableRow: {
    paddingLeft: "8px",
    paddingRight: "2px",
    width: "100%",
    height: "42px",
    display: "flex",
    justifyContent: "flex",
    alignItems: "center",
    "&$currencyTableRow:nth-child(even)": {
      backgroundColor: grayColor[13],
    },
  },
  currencyTableHeader: {
    fontSize: "16px",
    fontWeight: "bold",
    alignItems: "flex-start !important",
  },
  currencyTableColMonth: {
    width: "100px",
    paddingRight: "10px",
  },
  currencyTableColCurrency: {
    textAlign: "left",
    marginLeft: "6px",
    marginRight: "16px",
    width: "200px",
    minWidth: "200px",
    "&:last-child": {
      marginRight: "0",
      paddingRight: "4px",
    },
  },
  currencyTableColHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  currencyHeaderRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
  },
  currencyName: {
    fontWeight: "bold",
  },
  currencyActionButton: {
    margin: "0 !important",
    padding: "4px !important",
    width: "24px !important",
    height: "24px !important",
    minWidth: "24px !important",
    "& svg": {
      width: "14px",
      height: "14px",
    },
    "&:disabled": {
      backgroundColor: grayColor[10] + " !important",
      color: grayColor[1] + " !important",
      boxShadow: "none !important",
    },
  },
  currencyTableBodyCol: {},
  currencyTableCellWithRef: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  referenceRate: {
    fontSize: "14px",
    color: grayColor[1],
    fontWeight: "500",
  },
  referenceRateDimmed: {
    fontSize: "14px",
    color: grayColor[5],
    fontWeight: "400",
  },
  inputBold: {
    "& input": {
      fontWeight: "600 !important",
    },
  },
  referenceLabel: {
    fontSize: "11px",
    color: grayColor[2],
  },
  conversionLabel: {
    fontSize: "10px",
    color: grayColor[6],
    marginTop: "-2px",
    fontWeight: "normal",
    fontStyle: "italic",
  },
  moreButton: {
    padding: "2px !important",
    marginLeft: "auto",
    color: grayColor[1],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  saveButton: {
    "&:disabled": {
      backgroundColor: grayColor[10] + " !important",
      color: grayColor[1] + " !important",
      boxShadow: "none !important",
      opacity: "1 !important",
    },
  },
  inputAdornment: {
    marginLeft: "0",
    position: "relative",
  },
  inputAdornmentIconError: {
    color: dangerColor[0] + "!important",
  },
  removeCurrencyWarning: {
    marginTop: "12px",
    fontSize: "12px",
    fontStyle: "italic",
    lineHeight: "1.4",
  },
  currencyAlreadyExistsWarning: {
    marginTop: "12px",
    fontSize: "12px",
    lineHeight: "1.4",
    color: dangerColor[0],
  },
  invisible: {
    visibility: "hidden",
  },
  snackbarPaper: {
    width: "100%",
  },
  snackbarMessage: {
    maxWidth: "100% !important",
  },
});

export default exchangeRatesStyle;
